/**
 * AmbientLight2D Component
 *
 * Global ambient light — constant illumination applied everywhere.
 * Usually only one per scene. Supports color and temperature emission modes.
 */

import {
  component,
  displayName,
  icon,
  color,
  category,
  allowMultiple,
  executeInEditor,
  field,
  customEditor,
} from "../attributes";

@component("core.AmbientLight2D")
@customEditor("AmbientLight2DEditor")
@displayName("Ambient Light 2D")
@icon("CloudSun")
@color("#fcc419")
@category("Lighting")
@allowMultiple(false)
@executeInEditor(true)
export class AmbientLight2D {
  // ── Emission Mode ──
  @field({ type: "string", label: "Emission Mode", tooltip: "Color (direct RGB) or Temperature (Kelvin)" })
  emissionMode: string = "color";

  // ── Color Mode ──
  @field({ type: "color", label: "Color", tooltip: "Ambient light color. Used in Color mode." })
  color: { r: number; g: number; b: number; a: number } = { r: 26, g: 26, b: 26, a: 255 };

  // ── Temperature Mode ──
  @field({ type: "f32", label: "Temperature", min: 1000, max: 40000, step: 50, tooltip: "Color temperature in Kelvin (1000K warm → 40000K cool)" })
  temperature: number = 6500;

  @field({ type: "f32", label: "Tint", min: -1, max: 1, step: 0.01, tooltip: "Green–Magenta tint offset (−1 green, +1 magenta)" })
  tint: number = 0;

  // ── Shared ──
  @field({ type: "f32", label: "Intensity", min: 0, max: 10, step: 0.05, tooltip: "Ambient intensity" })
  intensity: number = 1.0;
}
